import Header from './components/Header';
import Hero from './components/Hero';
import CardsSection from './components/CardsSection';
import FeaturesSection from './components/FeaturesSection';
import IndexSection from './components/IndexSection';
import ContactSection from './components/ContactSection';
import UpdatesSection from './components/UpdatesSection';
import RankingSection from './components/RankingSection';
import CommentsSection from './components/CommentsSection';
import MediaSection from './components/MediaSection';
import TopicsSection from './components/TopicsSection';
import CarouselSection from './components/CarouselSection';
import AboutSection from './components/AboutSection';
import FaqSection from './components/FaqSection';
import AppSection from './components/AppSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <CardsSection />
        <FeaturesSection />
        <IndexSection />
        <ContactSection />
        <UpdatesSection />
        <RankingSection />
        <CommentsSection />
        <MediaSection />
        <TopicsSection />
        <CarouselSection />
        <AboutSection />
        <FaqSection />
        <AppSection />
      </main>
      <Footer />
    </>
  );
}